import * as React from 'react'
import styled, { AnyStyledComponent } from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { agentService, utilService } from '../../../../core/services'
import * as constants from '../../../../static/constants'
import { Button, Panel } from '../../../atoms'
import SidebarLayout from '../../_layouts/sidebarLayout'
import SvgIcon from 'components/atoms/SvgIcon'

interface IProps {
  guide_notification_type: IJsonResponse
  user: IJsonResponse
}

const AgentGuideNotificationTypeShow: React.FC<IProps> = props => {
  const { data: userData } = utilService.getDataFromJson(props.user)
  const { data: notificationType } = agentService.getDataFromJson(props.guide_notification_type)

  return (
    <SidebarLayout user={userData}>
      <Wrapper>
        <Panel title={`ガイド通知タイプ - ${notificationType.name}`}>
          <S.DetailWrapper>
            <S.DetailRow>
              <S.DetailLabel>ID</S.DetailLabel>
              <S.DetailValue>{notificationType.id}</S.DetailValue>
            </S.DetailRow>

            <S.DetailRow>
              <S.DetailLabel>名前</S.DetailLabel>
              <S.DetailValue>{notificationType.name}</S.DetailValue>
            </S.DetailRow>

            <S.DetailRow>
              <S.DetailLabel>アプリ内 タイトル</S.DetailLabel>
              <S.DetailValue>{notificationType.activity_title || '-'}</S.DetailValue>
            </S.DetailRow>

            <S.DetailRow>
              <S.DetailLabel>アプリ内 本文</S.DetailLabel>
              <S.DetailValue>
                <pre>{notificationType.activity_body || '-'}</pre>
              </S.DetailValue>
            </S.DetailRow>

            <S.DetailRow>
              <S.DetailLabel>アプリ内 リンクタイプ</S.DetailLabel>
              <S.DetailValue>{notificationType.activity_link_type || '-'}</S.DetailValue>
            </S.DetailRow>

            <S.DetailRow>
              <S.DetailLabel>メール件名</S.DetailLabel>
              <S.DetailValue>{notificationType.email_subject || '-'}</S.DetailValue>
            </S.DetailRow>

            <S.DetailRow>
              <S.DetailLabel>メール本文</S.DetailLabel>
              <S.DetailValue>
                <pre>{notificationType.email_body || '-'}</pre>
              </S.DetailValue>
            </S.DetailRow>

            <S.DetailRow>
              <S.DetailLabel>プッシュ通知データ</S.DetailLabel>
              <S.DetailValue>
                <pre>{notificationType.mobile_push_data || '-'}</pre>
              </S.DetailValue>
            </S.DetailRow>

            <S.DetailRow>
              <S.DetailLabel>Active</S.DetailLabel>
              <S.DetailValue>{notificationType.is_active ? '◯' : '✕'}</S.DetailValue>
            </S.DetailRow>

            <S.DetailRow>
              <S.DetailLabel>アプリ内お知らせ</S.DetailLabel>
              <S.DetailValue>{notificationType.is_activity ? '◯' : '✕'}</S.DetailValue>
            </S.DetailRow>

            <S.DetailRow>
              <S.DetailLabel>メール通知</S.DetailLabel>
              <S.DetailValue>{notificationType.is_email ? '◯' : '✕'}</S.DetailValue>
            </S.DetailRow>

            <S.DetailRow>
              <S.DetailLabel>プッシュ通知</S.DetailLabel>
              <S.DetailValue>{notificationType.is_mobile_push ? '◯' : '✕'}</S.DetailValue>
            </S.DetailRow>

            <S.DetailRow>
              <S.DetailLabel>短時間送信制限</S.DetailLabel>
              <S.DetailValue>{notificationType.short_limit}</S.DetailValue>
            </S.DetailRow>

            <div className="Buttons">
              <Button>
                <a href="/agent/guide_notification_types">
                  <SvgIcon
                    name="keyboard_arrow_left"
                    className="icon"
                    ariaHidden={true}
                    role="presentation"
                  />
                  {I18n.t('generic.back_to_index')}
                </a>
              </Button>
              <Button primary={true}>
                <a href={`/agent/guide_notification_types/${notificationType.id}/edit`}>
                  {I18n.t('generic.edit')}
                </a>
              </Button>
            </div>
          </S.DetailWrapper>
        </Panel>
      </Wrapper>
    </SidebarLayout>
  )
}

const S: { [key: string]: AnyStyledComponent } = {}

S.DetailWrapper = styled.div`
  padding: 0 24px;
`

S.DetailRow = styled.div`
  display: flex;
  padding: 16px 0;
  border-bottom: solid 1px ${constants.COLORS.divider};

  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    flex-direction: column;
    gap: 8px;
  }
`

S.DetailLabel = styled.div`
  min-width: 240px;
  font-size: 14px;
  font-weight: bold;
  color: ${constants.COLORS.subText};

  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    min-width: auto;
  }
`

S.DetailValue = styled.div`
  flex: 1;
  font-size: 14px;
  word-break: break-all;

  pre {
    white-space: pre-wrap;
    font-family: inherit;
    margin: 0;
  }
`

const Wrapper = styled.div`
  width: 100%;
  padding: 22px 40px 80px 46px;

  .Panel {
    max-width: none;
  }

  .Buttons {
    position: relative;
    display: flex;
    justify-content: center;
    margin-top: 48px;
    margin-bottom: 24px;

    .Button[type='button'] {
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      align-items: center;

      .icon {
        margin-left: -10px;
      }
    }

    .Button a {
      color: inherit;
      text-decoration: none;
    }
  }

  @media (max-width: ${constants.BREAKPOINT_DESKTOP}px) {
    padding: 16px 12px;
  }
`

export default AgentGuideNotificationTypeShow
